export class TicketTypeConfigSearchRequest{
    module:string;
    searchCriteria:string;

    constructor(module:string,searchCriteria:string){
        this.module = module;
        this.searchCriteria = searchCriteria;
    }
}